import React, { useState } from "react";
import {
  Group,
  Button,
  Image,
  SimpleGrid,
  FileInput,
  Text,
  Paper,
  rem,
  Loader,
  Notification,
} from "@mantine/core";
import { IconUpload, IconCheck, IconX } from "@tabler/icons-react";
import { uploadFile } from "../../api/ApiProduct";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";

// Giả lập hàm uploadFile, thay bằng API thực tế của bạn
// const uploadFile = async (files: File[], type: string) => { ... }

const UploadImageOnline = () => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [uploadedImages, setUploadedImages] = useState<
    { url: string; pathNameBefore?: string }[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleFileChange = (files: File[] | null) => {
    setSelectedFiles(files || []);
    setError(null);
    setSuccess(false);
  };

  const handleUpload = async () => {
    if (!selectedFiles.length) {
      setError("Vui lòng chọn ít nhất một ảnh để tải lên.");
      return;
    }
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const response = await uploadFile(selectedFiles, "productDetail");
      if (response && response.success) {
        setUploadedImages(response.data);
        setSuccess(true);
      } else {
        setError("Tải ảnh thất bại.");
      }
    } catch (e) {
      setError("Có lỗi xảy ra khi tải ảnh.");
    } finally {
      setLoading(false);
    }
  };
  console.log("Uploaded Images:", uploadedImages);
  return (
    <Paper
      shadow="md"
      p="xl"
      radius="md"
      style={{ maxWidth: 600, margin: "40px auto", background: "#fff" }}
    >
      <Text size="xl" mb="md">
        Tải lên nhiều ảnh sản phẩm
      </Text>
      <FileInput
        multiple
        accept="image/*"
        leftSection={<IconUpload size={18} />}
        placeholder="Chọn một hoặc nhiều ảnh..."
        value={selectedFiles}
        onChange={handleFileChange}
        disabled={loading}
        radius="md"
        size="md"
        mb="md"
        style={{ width: "100%" }}
      />
      <Group mb="md">
        <Button
          leftSection={
            loading ? <Loader size={16} /> : <IconUpload size={16} />
          }
          onClick={handleUpload}
          disabled={loading || !selectedFiles.length}
          size="md"
          radius="md"
          color="blue"
        >
          Tải lên
        </Button>
      </Group>
      {error && (
        <Notification color="red" icon={<IconX size={18} />} mb="md">
          {error}
        </Notification>
      )}
      {success && (
        <Notification color="green" icon={<IconCheck size={18} />} mb="md">
          Tải ảnh thành công!
        </Notification>
      )}
      {uploadedImages.length > 0 && (
        <>
          <Text size="md" mb="sm">
            Ảnh đã tải lên:
          </Text>
          <SimpleGrid cols={3} spacing="md">
            {uploadedImages.map((img, idx) => (
              <div
                key={idx}
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Image
                  src={img.url}
                  alt={img.pathNameBefore || `Ảnh ${idx + 1}`}
                  radius="md"
                  // placeholder có thể dùng nếu muốn, hoặc bỏ đi
                  height={140}
                  width={140}
                  fit="cover"
                  style={{
                    objectFit: "cover",
                    border: "1px solid #eee",
                    background: "#fafbfc",
                  }}
                  fallbackSrc="https://placehold.co/140x140?text=No+Image"
                />
                <Text
                  size="xs"
                  mt={4}
                  lineClamp={1}
                  title={img.url}
                  style={{
                    wordBreak: "break-all",
                    maxWidth: 140,
                    cursor: "pointer",
                    userSelect: "all",
                  }}
                  onDoubleClick={async () => {
                    try {
                      await navigator.clipboard.writeText(img.url);
                      NotificationExtension.Success("Đã copy link ảnh!");
                    } catch {}
                  }}
                >
                  {img.url}
                </Text>
              </div>
            ))}
          </SimpleGrid>
        </>
      )}
    </Paper>
  );
};

export default UploadImageOnline;
